var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowPointLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0766 0.5L16.9996 4.36003L3.92298 17.2268L-6.29607e-08 13.3668L13.0766 0.5Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.077 26.5L17 22.64L3.92339 9.77321L0.000414393 13.6332L13.077 26.5Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowPointLeft);
export default __webpack_public_path__ + "static/media/Icon_ArrowPoint_Left.bcaa8c40f413ca146e4166c641fdc76e.svg";
export { ForwardRef as ReactComponent };